/**
 * Person-name comparators, kept in their own module so pure logic can sort people without
 * importing `scripts/utils` - that module pulls in the API client, whose module graph is
 * circular under jest. `scripts/utils` re-exports both, so existing call sites are unchanged.
 */

/**
 * Compares by last name, ascending, despite the name: it moves the last word to the front and
 * compares from there. Every people list in the app is sorted with this.
 */
export function sortLastNamesDesc(a = '', b = '') {
  const name1 = a.trim().split(' ').reverse().join(' ');
  const name2 = b.trim().split(' ').reverse().join(' ');
  return name1.localeCompare(name2);
}

export function sortLastNamesAsc(a = '', b = '') {
  return -sortLastNamesDesc(a, b);
}
